import React from 'react';
import Box from '@mui/material/Box';
import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Loader from '@/components/common/Loader';
import { useCurrentUser } from '@/lib/hooks/userData';

const MOBILE_NAV_HEIGHT = '56px';
const SUPER_ADMIN_HEADER_HEIGHT = '64px';
const MOBILE_SUPER_ADMIN_HEADER_HEIGHT = '48px';

const DESKTOP_NAV_WIDTH = '80px';

type PageLoaderStyleProps = {
  isSuperAdmin: boolean;
};

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    // @ts-expect-error our theme does not match the Theme type exactly
    backgroundColor: theme.palette.grey.light,
    bottom: 0,
    left: DESKTOP_NAV_WIDTH,
    paddingRight: DESKTOP_NAV_WIDTH,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    right: 0,
    top({ isSuperAdmin }: PageLoaderStyleProps) {
      return isSuperAdmin ? SUPER_ADMIN_HEADER_HEIGHT : 0;
    },
    zIndex: 3,
    [theme.breakpoints.down('md')]: {
      left: 0,
      paddingRight: 0,
      top({ isSuperAdmin }: PageLoaderStyleProps) {
        return isSuperAdmin
          ? MOBILE_SUPER_ADMIN_HEADER_HEIGHT
          : MOBILE_NAV_HEIGHT;
      },
    },
  },
}));

type PageLoaderProps = {
  isVisible: boolean;
};

function PageLoader({ isVisible }: PageLoaderProps) {
  const { isSuperAdmin } = useCurrentUser();
  const classes = useStyles({
    isSuperAdmin,
  });

  return isVisible ? (
    <Box className={classes.container}>
      <Loader isVisible />
    </Box>
  ) : null;
}

export default PageLoader;
